<div class="no-results-message">{{ message }}</div>
